// The Auth0 popup's failure reply (api.wnfexchange.com W6 contract).

/** Backend W6 `login_error` codes -> what the visitor is told. */
const LOGIN_ERROR_TEXT: Record<string, string> = {
  missing_code_or_state: 'The sign-in was interrupted. Please try again.',
  invalid_state: 'The sign-in session expired or was opened twice. Please try again.',
  oauth_failed: 'The sign-in provider did not confirm your login. Please try again.',
  email_not_verified: 'Please verify your e-mail address first (check your inbox), then sign in again.',
  no_email: 'Your sign-in provider did not share an e-mail address, which WnF Exchange needs.',
}

/** A `login_error` reply from the popup — same origin + source checks as the
 * shared `Auth0LoginButton` applies to the success message. */
export function loginErrorFrom(event: MessageEvent, expectedOrigin: string): string | null {
  if (event.origin !== expectedOrigin) return null
  const data = event.data as { command?: unknown; error?: unknown; source?: unknown } | null
  if (!data || typeof data !== 'object') return null
  if (data.command !== 'login_error' || data.source !== 'auth0-login-popup') return null
  const code = typeof data.error === 'string' ? data.error : ''
  return LOGIN_ERROR_TEXT[code] ?? 'Sign-in failed. Please try again.'
}
